import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { Link } from 'react-router';

import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
import MediaList from '../../components/MediaList';
import NavBar from '../../components/NavBar';
import UploadModal from '../../components/UploadModal';
import ViewLarge from '../modals/ViewLarge';
import RemoveMedia from '../modals/RemoveMedia';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import {
  DEFAULT_PROMPT,
} from '../../constants/promptMessages';

import Form from './Form';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = {
      ...state,
      selectedMedia: null,
      showLarge: false,
      showDelete: false,
    };
    this.mediaList = null;
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  getToken(id, callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/medias/${id}/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
  }
  handleRefetch() {
    if (this.mediaList) {
      this.mediaList.getWrappedInstance().handleRefetch();
    }
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedMedia: null,
    });
  }
  handleViewLarge = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
      showLarge: true,
    });
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
      selectedMedia: null,
    });
  }
  handleDelete = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
      showDelete: true,
    });
  }
  handleConfirmDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
    }, () => {
      this.deleteMedia();
    });
  }
  createMedia = async (validations, media) => {
    const { t } = this.props;
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    try {
      await this.form.submit('/medias/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(media),
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.uploadModal.close();
    this.handleRefetch();
    store.dispatch(flashSuccessMessage({ header: t('Create Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully created', { ns: TRANSLATION_FILES.translation }) }));
  }
  deleteMedia() {
    const { t } = this.props;
    const { store } = this.context;
    this.getToken(this.state.selectedMedia.id, (token) => {
      store.dispatch(fetchM(`/medias/${this.state.selectedMedia.id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
      }))
        .then(() => {
          this.setState({
            selectedMedia: null,
            loading: false,
          });
          this.handleRefetch();
          store.dispatch(flashSuccessMessage({ header: t('Delete Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully deleted', { ns: TRANSLATION_FILES.translation }) }));
        })
        .catch((err) => {
          store.dispatch(flashErrorMessage(err));
        });
    });
  }
  handleCheckBeforeClose = () => {
    const { t } = this.props;
    if (this.form && this.form.state && this.form.state.hasChanges) {
      const callback = () => {
        this.uploadModal.close();
        this.handleRefetch();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(DEFAULT_PROMPT, { ns: TRANSLATION_FILES.translation }), callback }));
      return true;
    }
    return false;
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header="Videos"
          rightNav={
            <Menu.Item fitted>
              <UploadModal
                ref={(ref) => { this.uploadModal = ref; }}
                header="video"
                loading={this.state.loading}
                icon={null}
                btnText={t('New', { ns: TRANSLATION_FILES.constants })}
                onClose={this.handleCheckBeforeClose}
                content={() => (
                  <Form
                    ref={(ref) => { this.form = ref; }}
                    onSubmit={this.createMedia}
                  />
                )}
              />
            </Menu.Item>
          }
        />
        <ViewLarge
          open={this.state.showLarge}
          onClose={this.handleCloseLarge}
          picture={this.state.selectedMedia}
          type="video"
        />
        <RemoveMedia
          type="delete"
          open={this.state.showDelete}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          media={this.state.selectedMedia}
        />
        <MediaList
          ref={(ref) => { this.mediaList = ref; }}
          toggleable
          onViewLarge={this.handleViewLarge}
          onRemove={this.handleDelete}
          buttonNode={({ isMobile, view, loading, item }) => (
            view === 'list' ? (
              <div>
                <Button
                  as={Link}
                  size="tiny"
                  compact
                  primary
                  icon="edit"
                  content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                  disabled={loading}
                  to={`/media/videos/${item.id}/`}
                />
                <Button
                  size="tiny"
                  compact
                  negative
                  icon="remove"
                  content={isMobile ? null : t('Remove', { ns: TRANSLATION_FILES.translation })}
                  disabled={loading}
                  onClick={e => this.handleDelete(e, item)}
                />
              </div>
            ) : (
              <Button
                as={Link}
                compact size="small"
                attached="bottom"
                primary
                icon="edit" content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                disabled={loading}
                to={`/media/videos/${item.id}/`}
              />
            )
          )}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(List);



// WEBPACK FOOTER //
// ./src/containers/Videos/List.jsx